import api from '../../plugins/api';

const getRoles = (params) => {
  return api.get('/api/roles', params);
};

export default getRoles;
